// Tahir IP
// export const baseUrl = 'http://192.168.100.39:3100/api/v1/';

// http url
// export const baseUrl = 'http://51.112.28.13:3100/api/v1/';
// export const socketUrl = 'http://51.112.28.13:3100';

// http secure (https) url of deployed NMO Server

// export const baseUrl = 'https://api.nmoacademy.com/api/v1/';
export const socketUrl = 'https://api.nmoacademy.com';

// Hannan IP
// export const baseUrl = 'http://192.168.100.75:3100/api/v1';
// export const socketUrl = 'http://192.168.100.75:3100';

// Techverticks Admin Panel url
// export const baseUrl = 'http://192.241.151.241:8000/api/v1/';

// Khizer IP
// export const baseUrl = 'http://192.168.100.28:8000/api/v1/';

// new hostinger url
// export const baseUrl = 'http://31.97.99.190:8000/api/v1';
export const baseUrl = 'https://api.techverticks.com/api/v1';
